// extracted by mini-css-extract-plugin
export default {"container":"o2-z","heading":"p2-z","links":"q2-z","copy":"r2-z","subCopy":"s2-z","linksLeft":"t2-z","linksCenter":"u2-z","linksRight":"v2-z","link":"w2-z","onlyLink":"x2-z"};